import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment as Env} from '@src/environments/environment'

// const template = 'template1';
const routes: Routes = [
  {
    path: 'template1',
    loadChildren: () => import('@templates/template1/template1.module').then(m => m.Template1Module) //() => import(`@layouts/app-views/app-views.module`).then(m => m.AppViewsModule),
  },
  {
    path: 'template2',
    loadChildren: () => import('@templates/template2/template2.module').then(m => m.Template2Module) //() => import(`@layouts/app-views/app-views.module`).then(m => m.AppViewsModule),
  },
  {
    path: '',
    redirectTo: `/${Env.theme}/default`,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: `/${Env.theme}/default`,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
